/**
 * @exports
 * @class RenderPost
 */
import { removeURLParameter } from '../../helpers/utilities';

import { SinglePost } from './single-post';
import { singlePostTemplate } from './templates';

export class RenderPost {
    private url: string;
    private isLoading = false;

    /**
     * Initialises a new instance of RenderPost
     * 
     * @param url The URL of the single post
     */
    constructor(url: string) {
        this.url = url;

        this.getData();
    }


    /**
     * Get's the data for the single post
     * 
     * @private
     * @returns void
     */
    private getData(): void {
        if(this.isLoading) return;

        // Create our request and open the URL
        const request = new XMLHttpRequest();
        request.open('GET', `${this.url}?ajax`, true);

        // Identify as an Ajax Request
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        // Set our load event
        request.addEventListener('load', () => {
            if (request.status >= 200 && request.status < 400) {
                this.isLoading = false;
                
                // Pass the data to the renderer and then pass the response to the parser.
                const response    = JSON.parse(request.responseText) as SinglePostJSON;
                this.createTemplate(response);

                // Update the URL
                if(history.pushState) {
                    const historyURL = removeURLParameter('ajax', this.url);
                    history.pushState('', '', historyURL);
                }
            } else {
                this.isLoading = false;
                alert( 'There was an issue loading the next page of the content. Please try again later.');
            }
        });
        
        // Set our error handler
        request.addEventListener('error', () => {
            this.isLoading = false;
            alert( 'There was an issue loading the next page of the content. Please try again later.');
        });

        // Send the request
        request.send();
    }


    /**
     * Handles the JSON response
     * 
     * @param response THe JSON response
     * @private
     * @returns void
     */
    private createTemplate(response: SinglePostJSON): void {
        const htmlString = singlePostTemplate(response);
        new SinglePost(htmlString);
    }
}
